module.exports = __webpack_public_path__ + "img/AtomX-orange2.82994606.png";